export default __webpack_public_path__ + "static/media/ilustracao-dinheiro.50995e53.svg";